import { Box, Link, Typography } from '@mui/material'
import React from 'react'

const Disclaimer: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" padding={1}>
      <Typography variant="h1">XYO World 3.0 Fork</Typography>
      <Typography variant="body1">
        It was found that minting Dutch Auctions in XYO World caused the smart contract to revent. To fix this, we have redeployed the XYO World Smart
        Contracts with the state duplicated.
      </Typography>
      <Typography variant="body1">
        This means that the previous contracts stay out there (call it XYO World Classic version 1 and 2 if you want), but we will treat the new
        contract as the authority going forward.
      </Typography>
      <Typography variant="body1">
        This page describes the changes in detail to provide as much transparency as possible. If you have any questions, you can find me on Twitter
        at{' '}
        <Link href="https://twitter.com/arietrouw" target="_blank">
          @arietrouw
        </Link>
        , or you can email our{' '}
        <Link href="https://support.xyo.network" target="_blank">
          support team
        </Link>
        .
      </Typography>
      <Typography variant="body1">- Arie Trouw</Typography>
    </Box>
  )
}

export default Disclaimer
